import styled from 'styled-components'

export const AsideContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  height: auto;
  max-height: calc(100vh - 32px);
  min-height: 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`

export const AsideHeader = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0 12px;
  border-bottom: 1px solid #f0f0f0;
`

export const AsideTabs = styled.div`
  display: flex;
  gap: 6px;
  flex: 1;
`

export const AsideTab = styled.button.attrs({ type: 'button' as const })<{ $active: boolean }>`
  background: transparent;
  border: none;
  border-bottom: 2px solid ${(p) => (p.$active ? '#0090d3' : 'transparent')};
  color: ${(p) => (p.$active ? '#0090d3' : '#9ca3af')};
  font-size: 14px;
  font-weight: 600;
  padding: 14px 12px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: ${(p) => (p.$active ? '#0090d3' : '#374151')};
  }
`

export const CloseButton = styled.button.attrs({ type: 'button' as const })`
  align-self: center;
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #374151;
    background-color: #f3f4f6;
  }
`

export const AsideContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  min-height: 0;
  padding: 16px;
  gap: 16px;
  overflow-y: auto;
  max-height: calc(100vh - 120px);

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 3px;
  }
`

export const PreviewArea = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background-color: #f5f5f5;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const PreviewEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #9ca3af;
  text-align: center;
  padding: 16px;

  span {
    font-size: 14px;
    font-weight: 600;
  }

  small {
    font-size: 12px;
  }
`

export const IndexBadge = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #6d28d9;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const CoverBadge = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(75, 85, 99, 0.85);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  z-index: 2;
`

export const FileBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
  color: #4b5563;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 6px;
  text-transform: uppercase;
  width: 36px;
  height: 36px;
`

export const AsideThumbStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const AsideThumb = styled.button.attrs({ type: 'button' as const })<{ $active: boolean }>`
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  border: 2px solid ${(p) => (p.$active ? '#0090d3' : '#e5e7eb')};
  background-color: #f9fafb;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    border-color: ${(p) => (p.$active ? '#0090d3' : '#9ca3af')};
  }
`

export const ThumbMenuButton = styled.button.attrs({ type: 'button' as const })`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e7eb;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #4b5563;
`

export const AsideAddTile = styled.button.attrs({ type: 'button' as const })`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  border: 1px dashed #c7c7c7;
  background-color: transparent;
  color: #9ca3af;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: #0090d3;
    color: #0090d3;
  }
`

export const DocumentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DocumentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #fff;
`

export const DocumentRowName = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;

  span {
    font-size: 13px;
    color: #303030;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  small {
    font-size: 11px;
    color: #9ca3af;
  }
`

export const DocumentRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`

export const DocumentRowAction = styled.button.attrs({ type: 'button' as const })`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 16px;
  }
`

export const AsideEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #9ca3af;
  text-align: center;
  padding: 16px 8px;

  span {
    font-size: 14px;
    font-weight: 600;
  }

  small {
    font-size: 12px;
  }
`

export const AttachmentDropdownPortal = styled.div`
  position: fixed;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2147483647;
  width: fit-content;
  min-width: 180px;
  max-width: calc(100vw - 20px);
  overflow: hidden;
`

export const AttachmentDropdownItem = styled.button.attrs({ type: 'button' as const })`
  display: block;
  width: 100%;
  border: none;
  background: #fff;
  text-align: left;
  padding: 9px 12px;
  font-size: 13px;
  color: #303030;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
  }

  &.danger {
    color: #ef4444;
  }

  &.danger:hover {
    background: #fef2f2;
  }
`

export const CollapsedPill = styled.button.attrs({ type: 'button' as const })`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 8px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  color: #4b5563;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    color: #0090d3;
    border-color: #0090d3;
    background-color: #f0f9ff;
  }

  > svg {
    transform: rotate(180deg);
  }
`

export const CollapsedPillIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f0f9ff;
  color: #0090d3;
`

export const CollapsedPillLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`
